import { useParams } from 'react-router-dom';
import { useDisclosure, usePersonalLoan } from 'shared/hooks';
import { openDocument } from 'shared/utils';
import DisclosureReview from './DisclosureReview';

const DisclosureContainer = () => {
  const { uuid: personalLoanUuid } = useParams();
  const { personalLoan } = usePersonalLoan();
  const { disclosuresList, downloadDocument, loading: disclosureLoading } = useDisclosure(
    personalLoanUuid,
    personalLoan.status?.disclosurelistUuid
  );

  const handleDownload = (disclosure) => {
    const newWindow = window.open('', '_blank');

    downloadDocument(personalLoanUuid, personalLoan.status?.disclosurelistUuid, disclosure.document.uuid)
      .then((data) => openDocument(newWindow, data))
      .catch(() => newWindow.close());
  };

  if (disclosureLoading) return null;

  return <DisclosureReview disclosures={disclosuresList} handleDownload={handleDownload} personalLoanUuid={personalLoanUuid} />;
};

export default DisclosureContainer;
